import React from 'react';
import Summary from "../../common/Summary";

const PhysicianSummary = () => {
    return (
        <Summary ownsClaim={false} nextSteps={['If we need any additional information, we\'ll contact you by email.']}/>
    )
};

export default PhysicianSummary;
